import CloseIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

interface AllConfigsOffModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const TITLE_ID = 'all-configs-off-modal-title';

export const AllConfigsOffModal: React.FC<AllConfigsOffModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby={TITLE_ID}
    data-testid="all-configs-off-modal"
  >
    <DialogTitle component="div">
      <Typography variant="h6" component="h2" id={TITLE_ID}>
        All configurations turned off
      </Typography>
      <IconButton
        onClick={onClose}
        aria-label="Close"
        size="small"
        color="inherit"
        data-testid="all-configs-off-close"
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ mb: '12px' }}>
        Are you sure you want to turn off all configurations? Turning off
        configurations will have the following impact:
      </Typography>
      <Box component="ul" sx={{ pl: '20px', m: 0 }}>
        <li>
          Category <strong>will no longer be visible</strong> as a determined
          category <strong>in Resolution Hub</strong>
        </li>
        <li>
          Category <strong>will no longer be available for selection</strong> by
          reporters
        </li>
        <li>
          <strong>Routing rules</strong> that involve this category{' '}
          <strong>will be affected</strong>
        </li>
      </Box>
      <Typography sx={{ mt: '12px' }}>
        Insights remain unchanged and current reporters will not notice the
        change.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button
        variant="outlined"
        onClick={onClose}
        data-testid="all-configs-off-cancel-button"
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="destructive"
        onClick={onConfirm}
        autoFocus
        data-testid="all-configs-off-continue-button"
      >
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);
